import React from "react";
import { Container, Row, Col, Card, CardBody, Label, Input, Button, FormFeedback } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const BankDetails = props => {
  //meta title
  document.title = "Bank Details";
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      ss_id: '',
      beneficiary_name: '',
      bank_name: '',
      iban_no: '',
      routing_number: '',
      swift_code: '',
    },
    validationSchema: Yup.object({
      beneficiary_name: Yup.string()
        .matches(
          /^[a-zA-Z\s]+$/,
          'Please enter a valid value!'
        )
        .required('Beneficiary Name is required'),
      bank_name: Yup.string()
        .matches(
          /^[a-zA-Z\s]+$/,
          'Please enter a valid value!'
        )
        .required('Bank Name is required'),
      iban_no: Yup.string()
        .matches(
          /^[#0-9a-zA-Z]+$/,
          'Please enter a valid value!'
        )
        .required('IBAN is required'),
      routing_number: Yup.string()
        .matches(
          /^[#0-9]+$/,
          'Please enter a valid value!'
        )
        .required('Routing Number is required'),
      swift_code: Yup.string()
        .matches(
          /^[#0-9a-zA-Z]+$/,
          'Please enter a valid value!'
        )
        .required('Swift Code is required'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          ss_id: values.ss_id,
          beneficiary_name: values.beneficiary_name,
          bank_name: values.bank_name,
          iban_no: values.iban_no,
          routing_number: values.routing_number,
          swift_code: values.swift_code,  
        });
        const res = await postRequest('update-site-bank-details', jsonpar);
        if (res && res.code === 200) {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });
  
  const handleLoadGetSiteSettings = async () => {
    const res = await getRequest('get-site-settings');
    if (res && res.code === 200) {
      let originalText = res.data;
      validation1.setValues({
        ...validation1.values,
        ss_id: originalText.ss_id,
        beneficiary_name: originalText.beneficiary_name,
        bank_name: originalText.bank_name,
        iban_no: originalText.iban_no,
        routing_number: originalText.routing_number,
        swift_code: originalText.swift_code,
      });
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  React.useEffect(() => {
    handleLoadGetSiteSettings();
  }, []);


  return (
    <React.Fragment>
        {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
        <div className="page-content">
            <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title={props.t("Eshepay")} breadcrumbItem={props.t("Bank Details")} />

            <Row>
                <Col lg="12">
                    <form>
                        <Row>
                            <Col md={12} xs="12">
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col md={6} xs={12}>
                                                <div className="mb-3">
                                                <Label className="form-label">Beneficiary Name :</Label>
                                                <Input type="text" placeholder="Enter Beneficiary Name"
                                                    name="beneficiary_name"
                                                    onChange={validation1.handleChange}
                                                    onBlur={validation1.handleBlur}
                                                    value={validation1.values.beneficiary_name || ""}
                                                    invalid={
                                                    validation1.touched.beneficiary_name && validation1.errors.beneficiary_name ? true : false
                                                    }
                                                />
                                                {validation1.touched.beneficiary_name && validation1.errors.beneficiary_name ? (
                                                    <FormFeedback type="invalid">{validation1.errors.beneficiary_name}</FormFeedback>
                                                ) : null}
                                                </div>
                                            </Col>
                                            <Col md={6} xs={12}>
                                                <div className="mb-3">
                                                <Label className="form-label">Bank Name :</Label>
                                                <Input type="text" placeholder="Enter Bank Name"
                                                    name="bank_name"
                                                    onChange={validation1.handleChange}
                                                    onBlur={validation1.handleBlur}
                                                    value={validation1.values.bank_name || ""}
                                                    invalid={
                                                    validation1.touched.bank_name && validation1.errors.bank_name ? true : false
                                                    }
                                                />
                                                {validation1.touched.bank_name && validation1.errors.bank_name ? (
                                                    <FormFeedback type="invalid">{validation1.errors.bank_name}</FormFeedback>
                                                ) : null}
                                                </div>
                                            </Col>
                                            <Col md={6} xs={12}>
                                                <div className="mb-3">
                                                <Label className="form-label">IBAN :</Label>
                                                <Input type="text" placeholder="Enter IBAN"
                                                    name="iban_no"
                                                    onChange={validation1.handleChange}
                                                    onBlur={validation1.handleBlur}
                                                    value={validation1.values.iban_no || ""}
                                                    invalid={
                                                    validation1.touched.iban_no && validation1.errors.iban_no ? true : false
                                                    }
                                                />
                                                {validation1.touched.iban_no && validation1.errors.iban_no ? (
                                                    <FormFeedback type="invalid">{validation1.errors.iban_no}</FormFeedback>
                                                ) : null}
                                                </div>
                                            </Col>
                                            <Col md={6} xs={12}>
                                                <div className="mb-3">
                                                <Label className="form-label">Routing Number :</Label>
                                                <Input type="text" placeholder="Enter Routing Number"
                                                    name="routing_number"
                                                    onChange={validation1.handleChange}
                                                    onBlur={validation1.handleBlur}
                                                    value={validation1.values.routing_number || ""}
                                                    invalid={
                                                    validation1.touched.routing_number && validation1.errors.routing_number ? true : false
                                                    }
                                                />
                                                {validation1.touched.routing_number && validation1.errors.routing_number ? (
                                                    <FormFeedback type="invalid">{validation1.errors.routing_number}</FormFeedback>
                                                ) : null}
                                                </div>
                                            </Col>
                                            <Col md={6} xs={12}>
                                                <div className="mb-3">
                                                <Label className="form-label">Swift Code :</Label>
                                                <Input type="text" placeholder="Enter Swift Code"
                                                    name="swift_code"
                                                    onChange={validation1.handleChange}
                                                    onBlur={validation1.handleBlur}
                                                    value={validation1.values.swift_code || ""}
                                                    invalid={
                                                    validation1.touched.swift_code && validation1.errors.swift_code ? true : false
                                                    }
                                                />
                                                {validation1.touched.swift_code && validation1.errors.swift_code ? (
                                                    <FormFeedback type="invalid">{validation1.errors.swift_code}</FormFeedback>
                                                ) : null}
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className="text-left">
                                            <Button type="button" color="primary"
                                                id="submit1"
                                                onClick={(e) => {
                                                e.preventDefault();
                                                validation1.handleSubmit();
                                                return false;
                                                }}
                                                >Update</Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </form>
                </Col>
            </Row>
            </Container>
        </div>
    </React.Fragment>
  );
};

export default withTranslation()(BankDetails);
